import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook customizado que envia um postMessage para a janela pai sempre que a rota da página muda.
 * @param {object} options - Opções de configuração.
 * @param {string} [options.targetOrigin='*'] - A origem de destino para o postMessage. Por segurança, defina para a URL da página pai se possível.
 */
const usePageChangeNotifier = ({ targetOrigin = '*' } = {}) => {
  const location = useLocation();
  useEffect(() => {
    // Verifica se a janela atual é diferente da janela do topo (ou seja, se está em um iframe)
    // e se existe uma janela pai.
    if (1==1) {
      const message = {
        type: 'pagina-alterada',
        payload: {
          pathname: location.pathname,
          search: location.search,
          hash: location.hash,
        },
      };

      // Envia a mensagem para a janela pai
      window.parent.postMessage(message, targetOrigin);
      console.log('Mensagem de mudança de página enviada para o pai:', message);
    }
  }, [location, targetOrigin]); // O efeito é re-executado sempre que a 'location' ou 'targetOrigin' mudar
};

export default usePageChangeNotifier;